module.exports = __webpack_public_path__ + "17ca20d872f141c509d3e003b31075e5.svg";